export const INGRESOS = [
    {
        id: 0,
        nombre: "Honorarios Profesionales",
        text: true
    },
    {
        id: 1,
        nombre: "Sueldo o Salario",
        text: true
    },
    {
        id: 2,
        nombre: "Pensiones/Ayudas o Jubilaciones",
        text: true
    },
    {
        id: 3,
        nombre: "Alquileres y/o Arrendamientos",
        text: true
    },
    {
        id: 4,
        nombre: "Aportes Familiares",
        text: true
    },
    {
        id: 5,
        nombre: "Comercio Informal o Trabajo Independiente",
        text: true
    },
    {
        id: 6,
        nombre: "Becas",
        text: true
    },
    {
        id: 7,
        nombre: "Otros (Especifique):",
        text: false
    },
    {
        id: 8,
        nombre: "",
        text: false
    },
    {
        id: 9,
        nombre: "",
        text: false
    },
    {
        id: 10,
        nombre: "",
        text: false
    }
];

export const EGRESOS = [
    {
        id: 0,
        nombre: "Vivienda",
        text: true
    },
    {
        id: 1,
        nombre: "Alquileres o Arrendamientos",
        text: true
    },
    {
        id: 2,
        nombre: "Alimentación",
        text: true
    },
    {
        id: 3,
        nombre: "Educación",
        text: true
    },
    {
        id: 4,
        nombre: "Transporte",
        text: true
    },
    {
        id: 5,
        nombre: "Servicios Públicos",
        text: true
    },
    {
        id: 6,
        nombre: "Salud",
        text: true
    },
    {
        id: 7,
        nombre: "Recreación",
        text: true
    },
    {
        id: 8,
        nombre: "Ahorros",
        text: true
    },
    {
        id: 9,
        nombre: "Deudas/Préstamos",
        text: true
    },
    {
        id: 10,
        nombre: "Otros (Especifique):",
        text: false
    },
];


// WEBPACK FOOTER //
// ./src/shared/IngresosEgresos.jsx